import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;


@Component({

  selector: 'app-suppoort',

  templateUrl: './suppoort.component.html',

  styleUrls: ['./suppoort.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})
export class SuppoortComponent implements OnInit {

  list_Schools: any = [];

  list_Students: any = [];

  list_address = [];

  list_Status = [];

  list_Subject = [];

  list_feedback = [];

  filteredSchools = [];

  filteredStudents = [];

  lstPassenger: any = [];

  list_ActionType: any;

  list_previousAction: any = [];

  searchT_School = '';

  searchT_Student = '';

  iPassenger: number = -1;

  iMobileDomain: number = -1;

  dateFilter: FormGroup = this.FormBuilder.group({

    fromDate: new FormControl(''),

    toDate: new FormControl(''),

    actionDate: new FormControl('')

  })

  studentData: any;

  map: any;

  source: any;

  vector: any;

  layers: any = [];

  bOption: boolean = true;

  bSaveAction!: boolean;

  showAction: boolean = false;

  previousAction: boolean = false;

  isLoading: boolean = false;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.bSaveAction = JSON.parse(this.gurdService.decrypt(data)).bSchoolService_Tiket_SaveAction

    this.getSchools();

    this.getStatus();

    this.getSubject();

    this.getActionType()

  }

  filterSchool() {

    if (this.searchT_School == '') {

      this.filteredSchools = [];

      this.iMobileDomain = -1;

    }

    else this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));

  }

  filterStudent() {

    if (this.searchT_Student == '') {

      this.filteredStudents = [];

      this.iPassenger = -1;

    }

    else this.filteredStudents = this.list_Students.filter((item: any) => item.strPassenger_FullName.includes(this.searchT_Student));


  }

  onStudent_selected(item: any) {

    this.searchT_Student = item.strPassenger_FullName;

    this.iPassenger = item.iPassenger

    this.filteredStudents = [];


  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

  }

  async getStudent(item: any) {

    this.searchT_School = item.strComment;

    this.filteredSchools = [];

    this.iMobileDomain = item.iMobileDomain

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: '',

      strFullName: '',

      tiSex: -1,

      iMobileDomain: item.iMobileDomain

    }

    let res = JSON.parse((await axios.post(`School_Passenger_List`, model)).data.toString());

    this.list_Students = res;

    this.filteredStudents = res;


  }

  async getStatus() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_TiketStatus_List`, model)).data.toString());

    this.list_Status = res;

  }

  async getSubject() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_TiketSubject_List`, model)).data.toString());

    this.list_Subject = res;

  }

  async search_feedback(form: NgForm) {

    if (this.bOption == true) {

      this.isLoading = true;

      form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

      form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

      form.value['strSDate'] = this.dateFilter.value.fromDate;

      form.value['strEDate'] = this.dateFilter.value.toDate;

      form.value['iPassenger'] = this.iPassenger;

      form.value['iMobileDomain'] = this.iMobileDomain;

      form.value['tiType'] = 2;

      let res = JSON.parse((await axios.post(`School_Tiket_List`, form.value)).data.toString());

      this.list_feedback = res;

      this.bOption = false;

      this.isLoading = false;

      if (res.iResult == 0) return this.Notification.showError(res.strError)


    }

    else this.bOption = true;

  }

  async studentDetail(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    }

    let res = JSON.parse((await axios.post(`School_Passenger_Info`, model)).data.toString())[0];

    item.fDistance = res.fDistance;

    item.strName = res.strName;

    item.strFamily = res.strFamily;

    item.strNationalCode = res.strNationalCode.trim();

    item.strAvatar = res.strAvatar ? res.strAvatar : '';

    this.studentData = item;

    $('#detail_Std').modal('show');
  }

  async getActionType() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_TiketStatus_List`, model)).data.toString());

    this.list_ActionType = res;

  }

  async addAction(form: NgForm) {

    if (form.invalid) return this.Notification.showError('لطفا موارد ضروری را وارد کنید ');

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iTiket: this.studentData.iTiket,

      strActionDetail: form.value.strActionDetail,

      tiTiketStatus: form.value.tiTiketStatus


    }

    let res = JSON.parse((await axios.post(`School_TiketActions_Save`, model)).data.toString())[0];

    if (res.iTiket == this.studentData.iTiket) {

      $('#detailModal').modal('hide');

      return this.Notification.showSuccess('اقدام با موفقیت ثبت شد');

    }

    else return this.Notification.showError('خطایی رخ داده است')


  }

  async show_PreviousAction() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iTiket: this.studentData.iTiket

    }

    let res = JSON.parse((await axios.post(`School_TiketActions_List`, model)).data.toString());

    this.list_previousAction = res;

    this.previousAction = true

  }

  showDetail(item: any) {

    this.showAction = false;

    this.previousAction = false;

    this.studentData = item;

    $('#detailModal').modal('show');


  }

  goBack() {

    this.router.navigate(['/'])

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'پشتیبانی نرم افزاری.xlsx');

    }, 200);

  }

  showOnMap(item: any) {

    $('#stdLocation').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }


      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat([item.fOriginLon, item.fOrigiLat]),

          zoom: 13,

        }),

      });

    }, 500);

  }


}
